var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 34,
    stroke: "#314064",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 68C55.2401 68 68 55.2401 68 39.5C68 23.7599 55.2401 11 39.5 11C23.7599 11 11 23.7599 11 39.5",
    stroke: "#EFF3F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 42.6667C26.6665 37.6384 26.6665 35.1242 28.2286 33.5621C29.7907 32 32.3049 32 37.3332 32H42.6665C47.6948 32 50.209 32 51.7711 33.5621C53.3332 35.1242 53.3332 37.6384 53.3332 42.6667C53.3332 47.695 53.3332 50.2091 51.7711 51.7712C50.209 53.3333 47.6948 53.3333 42.6665 53.3333H37.3332C32.3049 53.3333 29.7907 53.3333 28.2286 51.7712C26.6665 50.2091 26.6665 47.695 26.6665 42.6667Z",
    stroke: "#314064",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3332 32.0001C45.3332 29.4859 45.3332 28.2288 44.5521 27.4478C43.7711 26.6667 42.514 26.6667 39.9998 26.6667C37.4857 26.6667 36.2286 26.6667 35.4476 27.4478C34.6665 28.2288 34.6665 29.4859 34.6665 32.0001",
    stroke: "#314064",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 44H31.9998C31.3713 44 31.057 44 30.8618 44.1953C30.6665 44.3905 30.6665 44.7048 30.6665 45.3333V46.6667C30.6665 47.2952 30.6665 47.6095 30.8618 47.8047C31.057 48 31.3713 48 31.9998 48H37.3332C37.9617 48 38.276 48 38.4712 47.8047C38.6665 47.6095 38.6665 47.2952 38.6665 46.6667V45.3333C38.6665 44.7048 38.6665 44.3905 38.4712 44.1953C38.276 44 37.9617 44 37.3332 44Z",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32.6667V44.0001M32 52.6667V48.6667",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32.6667V52.6667",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.7110853edc3b70f69af307a96e6ba770.svg";
export { ForwardRef as ReactComponent };